import React, { useState } from 'react'
import './Contact.css'
import SectionLabel from '../../components/SectionLabel/SectionLabel';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import PersonRoundedIcon from '@material-ui/icons/PersonRounded';
import EmailRoundedIcon from '@material-ui/icons/EmailRounded';

import { makeStyles } from '@material-ui/core/styles';
import { Button, Snackbar } from '@material-ui/core';
import { StylesProvider } from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';
import TwitterIcon from '@material-ui/icons/Twitter';
import MailRoundedIcon from '@material-ui/icons/MailRounded';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';

import * as firebase from 'firebase';
import 'firebase/firestore';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
        },
    },
}));

const SocialRow = (props) => {
    return (<div className="social-row">{props.image}<p>{props.children}</p></div>)
}


const Contact = () => {

    if (!firebase.apps.length) {
        firebase.initializeApp({
            apiKey: "AIzaSyC8MMW8mXg9IZPc_33FOhIgNadSMQ84V10",
            authDomain: "netiapps-web.firebaseapp.com",
            databaseURL: "https://netiapps-web.firebaseio.com",
            projectId: "netiapps-web",
            storageBucket: "netiapps-web.appspot.com",
            messagingSenderId: "268955160160",
            appId: "1:268955160160:web:2a4910537b469e18637d05",
            measurementId: "G-GTTQR5E7L8"
        });
    }

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [message, setMessage] = useState("");
    const [isValidMessage, setIsValidMessage] = useState(true);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [isSnackbarGood, setIsSnackbarGood] = useState(true);


    const classes = useStyles();

    const handleNameChange = (e) => {
        setName(e.target.value)
    }

    const handleEmailChange = (e) => {
        setEmail(e.target.value)
        if (!isValidEmail) {
            if (checkValidEmail(e.target.value)) setIsValidEmail(true)
        }
    }

    const handleMessageChange = (e) => {
        setMessage(e.target.value)
        if (!isValidMessage) {
            if (checkValidMessage(e.target.value)) setIsValidMessage(true)
        }
    }

    const handleSubmit = () => {
        const bEmail = checkValidEmail(email);
        const bMessage = checkValidMessage(message);

        if (!bEmail || !bMessage) {
            if (!bEmail) setIsValidEmail(false);
            if (!bMessage) setIsValidMessage(false);
        }
        else {
            //submit
            const lastTime = localStorage.getItem("lastMessageSent");
            const currTime = new Date().getTime();
            if (lastTime && currTime - lastTime < 60 * 10 * 1000) {
                setIsSnackbarGood(false);
                setSnackbarOpen(true);
            }
            else {
                const db = firebase.firestore();
                db.collection("messages").add(
                    {
                        email: email,
                        name: name,
                        message: message,
                        timestamp: new Date(),
                    }
                )

                if (!isSnackbarGood) setIsSnackbarGood(true);
                localStorage.setItem("lastMessageSent", new Date().getTime());
                setSnackbarOpen(true);
            }


        }



    }

    const checkValidEmail = email => {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    const checkValidMessage = message => {
        return message.length > 0;
    }

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    }

    return (
        <div id="contact">
            <SectionLabel label="Contact" />
            <StylesProvider>
                <div className="contact-container">
                    <div className="contact-title-container">
                        <p className="main-title">Let's contact!</p>
                        <p className="secondary-title">We’d love to hear from you</p>
                    </div>

                    <div className="contact-form-container">
                        <form className={classes.root}>
                            <TextField
                                className="form-input"
                                id="outlined"
                                label="Name"
                                type="text"
                                variant="outlined"
                                onChange={handleNameChange}
                                value={name}
                                inputProps={{ maxLength: 30 }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <PersonRoundedIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <TextField
                                className="form-input"
                                required
                                id="outlined-required"
                                label="Email"
                                type="email"
                                variant="outlined"
                                inputProps={{ maxLength: 50 }}
                                onChange={handleEmailChange}
                                value={email}
                                error={isValidEmail ? false : true}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <EmailRoundedIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <TextField
                                className="form-input"
                                id="outlined-multiline-static"
                                label="Message"
                                multiline
                                rows={6}
                                onChange={handleMessageChange}
                                value={message}
                                inputProps={{ maxLength: 1000}}
                                variant="outlined"
                                error={isValidMessage ? false : true}
                            />
                            <Button variant="contained" color="primary" className="submit-button" onClick={handleSubmit}>
                                Submit
                        </Button>
                        </form>
                    </div>

                    <div className="contact-socials-container">
                        <p>Contact us directly</p>
                        <SocialRow image={<MailRoundedIcon />}>NetiAppsInfo@gmail.com</SocialRow>
                        <SocialRow image={<InstagramIcon />}>netiapps_</SocialRow>
                        <SocialRow image={<FacebookIcon />}>@NETIAppsBest</SocialRow>
                        <SocialRow image={<TwitterIcon />}>@_NETIApps</SocialRow>
                    </div>
                </div>
            </StylesProvider>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}>
                <Alert onClose={handleSnackbarClose} severity={isSnackbarGood ? "success" : "error"}>
                    {isSnackbarGood ? "Message Submitted!" : "Please wait 10 minutes before sending again..."}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default Contact
